import { render } from "./OverallFeedback.vue?vue&type=template&id=533635c8&scoped=true"
import script from "./OverallFeedback.vue?vue&type=script&lang=js"
export * from "./OverallFeedback.vue?vue&type=script&lang=js"

import "./OverallFeedback.vue?vue&type=style&index=0&id=533635c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533635c8"]])

export default __exports__